import React from 'react'
import { useNavigate } from 'react-router-dom'
import { isLoggedIn } from '../utils/api'
import './LandingPage.css'

const LineIcon: React.FC<{ type: 'form' | 'bolt' | 'card' | 'shield' | 'search' }> = ({ type }) => {
  const paths = {
    form: <><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v5h5M10 12h6M10 16h6" /></>,
    bolt: <path d="M13 2 5 14h7l-1 8 8-12h-7z" />,
    card: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18M7 15h3" /></>,
    shield: <><path d="M12 3 5 6v5c0 4.6 2.8 8 7 10 4.2-2 7-5.4 7-10V6z" /><path d="m9 12 2 2 4-4" /></>,
    search: <><circle cx="11" cy="11" r="6" /><path d="m16 16 4 4" /></>,
  }
  return <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{paths[type]}</svg>
}

const LandingPage: React.FC = () => {
  const navigate = useNavigate()
  const handleApply = () => navigate(isLoggedIn() ? '/application' : '/login')

  return (
    <div className="lp-root">
      <header className="lp-header">
        <span className="lp-logo"><span className="lp-flag" /> Pinjaman Kilat</span>
      </header>

      <section className="lp-hero">
        <h1 className="lp-title">
          Pinjaman Online<br />
          <span className="lp-accent">Cepat dan Praktis</span>
        </h1>
        <p className="lp-desc">
          Ajukan hingga <strong>Rp10.000.000</strong> tanpa jaminan.
        </p>
        <div className="lp-quick-info">
          <div><span><LineIcon type="form" /></span><strong>Isi Data</strong><small>Secara online</small></div>
          <i>→</i>
          <div><span><LineIcon type="bolt" /></span><strong>Verifikasi</strong><small>Proses praktis</small></div>
          <i>→</i>
          <div><span><LineIcon type="card" /></span><strong>Hasil</strong><small>Sesuai penilaian</small></div>
        </div>
        <button className="lp-cta" onClick={handleApply}>Ajukan Pinjaman Sekarang →</button>
        <p className="lp-summary">Rp1–10 juta &nbsp;·&nbsp; 90–180 hari</p>
        <p className="lp-note">Manfaat ekonomi maks. 0,3% per hari. Rincian final ditampilkan sebelum persetujuan.</p>
      </section>

      <section className="lp-features">
        <div className="lp-feature"><span className="lp-fi"><LineIcon type="bolt" /></span><strong>Proses Praktis</strong><p>Ajukan secara online dengan langkah sederhana.</p></div>
        <div className="lp-feature"><span className="lp-fi"><LineIcon type="shield" /></span><strong>Data Terlindungi</strong><p>Informasi pribadi diproses secara aman.</p></div>
        <div className="lp-feature"><span className="lp-fi"><LineIcon type="search" /></span><strong>Biaya Transparan</strong><p>Rincian ditampilkan sebelum Anda menyetujui.</p></div>
      </section>

      <footer className="lp-footer">
        <p>Pinjaman Kilat Indonesia</p>
        <p>Pinjaman memiliki risiko. Ajukan sesuai kebutuhan dan kemampuan membayar.</p>
      </footer>
    </div>
  )
}

export default LandingPage
